var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDribbleWhite = function SvgDribbleWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dribble-white",
    transform: "translate(-2.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_11",
    "data-name": "Exclusion 11",
    d: "M-3315.5,842.5h0a9.018,9.018,0,0,1-6.048-2.25,9.314,9.314,0,0,1-2.952-6.75,9.312,9.312,0,0,1,2.952-6.75,9.017,9.017,0,0,1,6.048-2.25,9.018,9.018,0,0,1,6.049,2.25,9.309,9.309,0,0,1,2.951,6.75,9.308,9.308,0,0,1-2.95,6.749A9.019,9.019,0,0,1-3315.5,842.5Zm1.444-7.7h0a.153.153,0,0,1-.032.012l-.016,0a10.871,10.871,0,0,0-6.167,4.919,7.808,7.808,0,0,0,4.888,1.659,7.309,7.309,0,0,0,3-.621,32.723,32.723,0,0,0-1.677-5.974Zm3.2-.507a10.441,10.441,0,0,0-1.643.127,35.213,35.213,0,0,1,1.536,5.641,7.973,7.973,0,0,0,3.38-5.3A11.65,11.65,0,0,0-3310.857,834.291Zm-12.627-1.042h0a8.083,8.083,0,0,0,2.067,5.643,12.782,12.782,0,0,1,6.548-5.329l.031-.01c.094-.03.189-.061.288-.086-.191-.435-.411-.9-.654-1.37a30,30,0,0,1-8.058,1.153h-.22Zm12.217-.1a19.328,19.328,0,0,1,3.779.373,8.144,8.144,0,0,0-1.829-5.072,10.807,10.807,0,0,1-4.531,3.208c.236.474.468,1,.71,1.6A15.135,15.135,0,0,1-3311.267,833.144Zm-7.561-6.866a8.189,8.189,0,0,0-4.493,5.7h.129a30.433,30.433,0,0,0,7.374-.991,51.47,51.47,0,0,0-3.01-4.708Zm3.325-.776a8.5,8.5,0,0,0-1.9.229,43.385,43.385,0,0,1,3.028,4.763,9.124,9.124,0,0,0,4.251-2.938,8.063,8.063,0,0,0-5.379-2.054Z",
    transform: "translate(3327 -822)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDribbleWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dribble-white.668f31d2.svg";
export { ForwardRef as ReactComponent };